module.exports = __webpack_public_path__ + "img/mainLogo.0deb50c4.svg";